<template>
  <div id="app" class="w-100 flex flex-column items-center">
    <header class="ph4 pt4 pb3 pv5-l ph4-m ph5-l w-100 w-60-l h4">
      <nav class="f6 fw6 ttu tracked ml5-l ml4-m" @click="toggleMenu">
        <ul class="list w-10 fr mt0 pl0 pointer">
            <li class="hamb mb2" :class="{hambMiddle : menuIn, hambSide   : ! menuIn}"></li>
            <li class="hamb mb2" :class="{hambSide   : menuIn, hambMiddle : ! menuIn}"></li>
            <!-- <li class="hamb"     :class="{hambMiddle : menuIn, hambSide   : ! menuIn}"></li> -->
        </ul>
        <transition name="slide-fade">
          <div class="fl b w-90 w-80-l flex flex-wrap" v-if="menuIn">
            <router-link @click.native="toggleMenu" to="/" class="link dim mr3 mb2 main-blue">Home</router-link>
            <router-link @click.native="toggleMenu" to="/vuetter" class="link dim mr3 mb2 main-blue">Vuetter</router-link>
            <router-link @click.native="toggleMenu" to="/mowpi" class="link dim mr3 mb2 main-blue">Mowpi</router-link>
            <router-link @click.native="toggleMenu" to="/extras" class="link dim mr3 mb2 main-blue">Extra</router-link>
            <router-link @click.native="toggleMenu" to="/contact" class="link dim main-blue mb2">Contact</router-link>
          </div>
        </transition>
      </nav>
    </header>
    <div class="w-100 ">
      <!-- <div class="fl-l w-20-l flex flex-column items-center">
        <article class="center bg-white br3 pa3 pa4-ns mv3 ba b--black-10 w-80 w-100-l">
          <div class="tc">
            <img src="./assets/lcamero.jpg" class="br-100 h4 w4 dib ba b--black-05 pa2" title="Photo of Luis staring at you">
            <h1 class="f3 mb2">Luis C.</h1>
            <h2 class="f5 fw4 gray mt0">Software Engineer</h2>
          </div>
        </article>
      </div> -->
      <transition name="slide-fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      menuIn: false
    }
  },
  methods: {
    toggleMenu () {
      this.menuIn = !this.menuIn
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: Raleway, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(30px);
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}
::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.o-scroll {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/App.vue